<script setup lang="ts">
import { computed, ref } from 'vue';
import { buttonMessages, usercontrolMessages } from '../../messages';

const props = withDefaults(
  defineProps<{
    error?: unknown;
    reloading?: boolean;
  }>(),
  {
    error: null,
    reloading: false,
  },
);

const dismissedError = ref<unknown>(null);

const shown = computed(
  () => !!props.error && props.error !== dismissedError.value,
);
</script>

<template>
  <div
    v-if="shown"
    class="alert alert-danger d-flex align-items-center m-2 py-2 mb-0"
    role="alert"
  >
    <span class="flex-grow-1">
      {{ reloading ? usercontrolMessages.reloading : error }}
    </span>
    <button
      type="button"
      class="close ms-2"
      :aria-label="buttonMessages.close"
      @click="dismissedError = error"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>
